import { FiltersIcon } from '@kijiji/icons/src/icons'
import { theme } from '@kijiji/theme'
import { useTranslation } from 'next-i18next'

import { ALL_CATEGORIES_ID_NUM } from '@/constants/category'
import {
  AllFiltersButtonStyles,
  FilterCountBadge,
  QuickFilterButtonText,
} from '@/features/filters/components/QuickFilters/styled'
import { useGetSearchResultsData } from '@/hooks/srp/useGetSearchResultsData'
import { Flex } from '@/ui/atoms/flex'

type AllFilterButtonProps = {
  onClick: () => void
  isSrpControlsMobileToggleEnabled?: boolean
}

export const AllFiltersButton = ({
  onClick,
  isSrpControlsMobileToggleEnabled = false,
}: AllFilterButtonProps) => {
  const { t } = useTranslation(['srp'])
  const { data: { searchQuery } = {} } = useGetSearchResultsData()

  const appliedFiltersCount =
    (searchQuery?.filters?.length ?? 0) +
    (searchQuery?.category?.id === ALL_CATEGORIES_ID_NUM ? 0 : 1)

  return (
    <AllFiltersButtonStyles
      aria-label={t('filters.all_filters_label', { count: appliedFiltersCount })}
      shape="pill"
      size="compact"
      onClick={onClick}
    >
      <Flex
        justifyContent="space-around"
        alignItems="center"
        gap={theme.spacing.mini}
        flexGrow={1}
        style={{ maxWidth: '100%' }}
      >
        <FiltersIcon size="xsm" style={{ flexShrink: 0 }} />
        {!isSrpControlsMobileToggleEnabled && (
          <QuickFilterButtonText>{t('filters.all_filters')}</QuickFilterButtonText>
        )}
        {appliedFiltersCount ? (
          <FilterCountBadge alignItems="center" justifyContent="center">
            {appliedFiltersCount}
          </FilterCountBadge>
        ) : null}
      </Flex>
    </AllFiltersButtonStyles>
  )
}
